import { ReactFlowProvider } from '@xyflow/react';
import clsx from 'clsx';
import React, { useState } from 'react';

import { Heading } from '@/components/typography/heading';

import styles from '../../contractDetails.module.scss';
import { EntityRelationshipDiagram } from '../EntityRelationshipDiagram';
import { DataTypeDescriptionsTab } from './DataTypeDescriptionsTab';
import { ModelExamplesTab } from './ModelExamplesTab';

interface Model {
  description?: string;
  fields?: Record<string, any>;
}

interface DataModelSectionProps {
  models: Record<string, Model>;
  diagramNodes: any[];
  diagramEdges: any[];
  nodeTypes: any;
}

type TabType = 'relationships' | 'types' | 'examples';

export function DataModelSection( {
  models,
  diagramNodes,
  diagramEdges,
  nodeTypes
}: DataModelSectionProps ) {
  const [ activeTab, setActiveTab ] = useState<TabType>( 'relationships' );

  return (
    <div className={ clsx( 'layout__row', 'pad' ) }>
      <div className={ clsx( styles.card, styles.noBorderCard ) } data-testid='data-model-card'>
        <div className={ clsx( styles.cardHeader, styles.cardHeaderWithTabs ) }>
          <Heading as='h3' size='sm'>Data Model</Heading>
          <div className={ styles.tabMenu }>
            <button
              className={ clsx( styles.tabButton, { [styles.tabButtonActive]: activeTab === 'relationships' } ) }
              onClick={ () => setActiveTab( 'relationships' ) }
              data-testid='tab-entity-relationships'
            >
              Entity Relationships
            </button>
            <span className={ styles.tabSeparator }>|</span>
            <button
              className={ clsx( styles.tabButton, { [styles.tabButtonActive]: activeTab === 'types' } ) }
              onClick={ () => setActiveTab( 'types' ) }
              data-testid='tab-data-type-descriptions'
            >
              Data Type Descriptions
            </button>
            <span className={ styles.tabSeparator }>|</span>
            <button
              className={ clsx( styles.tabButton, { [styles.tabButtonActive]: activeTab === 'examples' } ) }
              onClick={ () => setActiveTab( 'examples' ) }
              data-testid='tab-model-examples'
            >
              Model Examples
            </button>
          </div>
        </div>
        <div className={ styles.cardBody }>
          <div className={ styles.tabContent }>
            { activeTab === 'relationships' && (
              <div className={ styles.tabPanel } data-testid='panel-entity-relationships'>
                <ReactFlowProvider>
                  <EntityRelationshipDiagram
                    nodes={ diagramNodes }
                    edges={ diagramEdges }
                    nodeTypes={ nodeTypes }
                  />
                </ReactFlowProvider>
              </div>
            ) }

            { activeTab === 'types' && (
              <DataTypeDescriptionsTab models={ models } />
            ) }

            { activeTab === 'examples' && (
              <ModelExamplesTab models={ models } />
            ) }
          </div>
        </div>
      </div>
    </div>
  );
}
